var swiper = new Swiper(".text-col-swiper", {
    slidesPerView: 1.5,
    spaceBetween: 25,
    paginationClickable: false,
    centeredSlides: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
      }
    }
  });
  